import React from 'react';

function FollowUpQuestions({ questions, answers, setAnswers }) {
  function update(question, value) {
    setAnswers({ ...answers, [question]: value });
  }

  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <div className="ff-card" data-testid="follow-up-questions">
      <h2>Follow-Up Questions</h2>
      <p className="ff-card-description">
        These questions are meant to sharpen the facts and improve the final output.
      </p>

      <div className="ff-questions-list">
        {questions.map((question, index) => (
          <div key={index} className="ff-question-item">
            <label className="ff-label">{question}</label>
            <textarea
              className="ff-textarea ff-textarea-small"
              value={answers[question] || ''}
              onChange={(e) => update(question, e.target.value)}
              placeholder="Your answer..."
              rows={3}
              data-testid={`follow-up-${index}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default FollowUpQuestions;
